import { render, staticRenderFns } from "./EditPromotions.vue?vue&type=template&id=827d3530"
import script from "./EditPromotions.vue?vue&type=script&lang=js"
export * from "./EditPromotions.vue?vue&type=script&lang=js"
import style0 from "./EditPromotions.vue?vue&type=style&index=0&id=827d3530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports